<div class="survey-template-settings-container">
    <div class="settings-header">
        <h2>SURVEY TEMPLATE SETTINGS</h2>
        <p class="hint">Customize your patient satisfaction survey template. This template will be used for all new
            surveys sent to patients.</p>
    </div>

    <!-- <div class="loading-container" *ngIf="isLoading">
        <mat-spinner></mat-spinner>
        <p>Loading survey template...</p>
    </div> -->
    <mat-accordion multi="true" [formGroup]="templatesForm">
        <div formArrayName="templates">
            <mat-expansion-panel *ngFor="let template of templatesArray.controls; let i = index" [formGroupName]="i"
                [expanded]="expandedTemplates.get(template.value.id) ?? false"
                (opened)="expandedTemplates.set(template.value.id, true)"
                (closed)="expandedTemplates.set(template.value.id, false)">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ template.get('surveyTitle')?.value?.toUpperCase() ?? ' NEW SURVEY TEMPLATE'
                        }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="full-width">
                    <div class="template-form">
                        <!-- Basic Template Information -->
                        <h4>Basic Information</h4>
                        <!--   <div class="form-row">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Template Name</mat-label>
                                    <input matInput formControlName="name" placeholder="Enter template name">
                                    <mat-error *ngIf="surveyTemplateForm.get('name')?.hasError('required')">
                                        Template name is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                
                            <div class="form-row">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Description</mat-label>
                                    <textarea matInput formControlName="description" placeholder="Enter template description"
                                        rows="2"></textarea>
                                </mat-form-field>
                            </div> -->

                        <div class="form-row">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Survey Title</mat-label>
                                <input matInput formControlName="surveyTitle" placeholder="Enter survey title">
                                <mat-error *ngIf="template.get('surveyTitle')?.hasError('required')">
                                    Survey title is required
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- <div class="form-row">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Survey Introduction</mat-label>
                                <textarea matInput formControlName="surveyIntroduction"
                                    placeholder="Enter survey introduction text" rows="3"></textarea>
                            </mat-form-field>
                        </div> -->

                        <!-- Survey Sections -->
                        <h4>Survey Sections</h4>
                        <p class="hint">Organize your survey into logical sections</p>
                        <div formGroupName="surveyConfig">
                            <div formArrayName="sections" cdkDropList (cdkDropListDropped)="onSectionDrop($event, i)">
                                <div *ngFor="let section of getSectionsArray(i).controls; let sectionIndex = index"
                                    [formGroupName]="sectionIndex" class="section-container" cdkDrag>

                                    <mat-expansion-panel class="section-panel"
                                        [expanded]="isSectionExpanded(template.value.id, section.value.id)"
                                        (opened)="toggleSection(template.value.id, section.value.id)"
                                        (closed)="toggleSection(template.value.id, section.value.id)">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <mat-icon cdkDragHandle class="drag-handle">drag_indicator</mat-icon>
                                                <h4 class>{{section.get('title')?.value}}</h4>
                                            </mat-panel-title>
                                            <mat-panel-description>
                                                <button mat-icon-button (click)="removeSection(i, sectionIndex)"
                                                    matTooltip="Remove section" class="remove-button">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>

                                        <div class="section-content">
                                            <!-- Section Description -->
                                            <div class="form-row">
                                                <mat-form-field appearance="outline" class="full-width">
                                                    <mat-label>Section Title</mat-label>
                                                    <input matInput formControlName="title"
                                                        placeholder="Enter section title">
                                                    <mat-error *ngIf="section.get('title')?.hasError('required')">
                                                        Section title is required
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <!-- Section Description -->
                                            <!--  <div class="form-row">
                                                    <mat-form-field appearance="outline" class="full-width">
                                                        <mat-label>Section Description</mat-label>
                                                        <textarea matInput formControlName="description"
                                                            placeholder="Enter section description" rows="2"></textarea>
                                                    </mat-form-field>
                                                </div> -->

                                            <!-- Questions -->
                                            <div class="questions-container">
                                                <div class="questions-header">
                                                    <h4>Questions</h4>
                                                    <button mat-raised-button color="primary"
                                                        (click)="addQuestion(i, sectionIndex)">
                                                        <mat-icon>add</mat-icon>
                                                        Add Question
                                                    </button>
                                                </div>

                                                <div formArrayName="questions">
                                                    <div *ngFor="let question of asFormArray(section.get('questions')).controls; let questionIndex = index"
                                                        [formGroupName]="questionIndex" class="question-container">

                                                        <mat-card class="question-card">
                                                            <mat-card-content>
                                                                <div class="question-header">
                                                                    <mat-form-field appearance="outline"
                                                                        class="question-field">
                                                                        <mat-label>Question</mat-label>
                                                                        <textarea matInput formControlName="question"
                                                                            placeholder="Enter your question"
                                                                            rows="2"></textarea>
                                                                        <mat-error
                                                                            *ngIf="question.get('question')?.hasError('required')">
                                                                            Question is required
                                                                        </mat-error>
                                                                    </mat-form-field>

                                                                    <button mat-icon-button
                                                                        (click)="removeQuestion(i, sectionIndex, questionIndex)"
                                                                        matTooltip="Remove question"
                                                                        class="remove-button">
                                                                        <mat-icon>delete</mat-icon>
                                                                    </button>
                                                                </div>

                                                                <div class="question-settings">
                                                                    <div class="form-row">
                                                                        <mat-form-field appearance="outline"
                                                                            class="question-type-field">
                                                                            <mat-label>Question Type</mat-label>
                                                                            <mat-select formControlName="type"
                                                                                (selectionChange)="onQuestionTypeChange(i, sectionIndex, questionIndex, $event.value)">
                                                                                <mat-option value="radio">Multiple
                                                                                    Choice</mat-option>
                                                                                <mat-option value="textarea">Text
                                                                                    Response</mat-option>
                                                                            </mat-select>
                                                                        </mat-form-field>

                                                                        <mat-checkbox formControlName="required"
                                                                            class="required-checkbox">
                                                                            Required Question
                                                                        </mat-checkbox>
                                                                    </div>

                                                                    <!-- Textarea placeholder -->
                                                                    <div class="form-row"
                                                                        *ngIf="question.get('type')?.value === 'textarea'">
                                                                        <mat-form-field appearance="outline"
                                                                            class="full-width">
                                                                            <mat-label>Placeholder
                                                                                Text</mat-label>
                                                                            <input matInput
                                                                                formControlName="placeholder"
                                                                                placeholder="Enter placeholder text">
                                                                        </mat-form-field>
                                                                    </div>

                                                                    <!-- Radio options -->
                                                                    <div class="options-container"
                                                                        *ngIf="question.get('type')?.value === 'radio'">
                                                                        <div class="options-header">
                                                                            <h5>Answer Options</h5>
                                                                            <button mat-raised-button color="accent"
                                                                                (click)="addOption(i, sectionIndex, questionIndex)">
                                                                                <mat-icon>add</mat-icon>
                                                                                Add Option
                                                                            </button>
                                                                        </div>

                                                                        <div formArrayName="options">
                                                                            <div *ngFor="let option of getOptionsArray(i, sectionIndex, questionIndex).controls; let optionIndex = index"
                                                                                [formGroupName]="optionIndex"
                                                                                class="option-container">

                                                                                <div class="option-row">
                                                                                    <mat-form-field appearance="outline"
                                                                                        class="option-value-field">
                                                                                        <mat-label>Value</mat-label>
                                                                                        <input matInput
                                                                                            formControlName="value"
                                                                                            placeholder="e.g., yes, no">
                                                                                        <mat-error
                                                                                            *ngIf="option.get('value')?.hasError('required')">
                                                                                            Value is required
                                                                                        </mat-error>
                                                                                    </mat-form-field>

                                                                                    <mat-form-field appearance="outline"
                                                                                        class="option-text-field">
                                                                                        <mat-label>Display
                                                                                            Text</mat-label>
                                                                                        <input matInput
                                                                                            formControlName="text"
                                                                                            placeholder="e.g., Yes, No">
                                                                                        <mat-error
                                                                                            *ngIf="option.get('text')?.hasError('required')">
                                                                                            Display text is
                                                                                            required
                                                                                        </mat-error>
                                                                                    </mat-form-field>

                                                                                    <mat-form-field appearance="outline"
                                                                                        class="option-score-field">
                                                                                        <mat-label>Score</mat-label>
                                                                                        <input matInput type="number"
                                                                                            formControlName="score"
                                                                                            min="1" max="5">
                                                                                        <mat-error
                                                                                            *ngIf="option.get('score')?.hasError('required')">
                                                                                            Score is required
                                                                                        </mat-error>
                                                                                        <mat-error
                                                                                            *ngIf="option.get('score')?.hasError('min') || option.get('score')?.hasError('max')">
                                                                                            Score must be
                                                                                            between 1
                                                                                            and 5
                                                                                        </mat-error>
                                                                                    </mat-form-field>

                                                                                    <button mat-icon-button
                                                                                        (click)="removeOption(i, sectionIndex, questionIndex, optionIndex)"
                                                                                        matTooltip="Remove option"
                                                                                        class="remove-button">
                                                                                        <mat-icon>delete</mat-icon>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </mat-card-content>
                                                        </mat-card>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-expansion-panel>
                                </div>
                            </div>
                        </div>

                        <div class="add-section-container">
                            <button mat-raised-button color="primary" (click)="addSection(i)">
                                <mat-icon>add</mat-icon>
                                Add Section
                            </button>
                        </div>

                        <!-- Survey Timing Section -->
                        <div class="survey-timing-section">
                            <h4>Survey Timing</h4>
                            <p class="hint">Configure when this survey should be automatically sent to patients.</p>

                            <div class="timing-controls">
                                <mat-slide-toggle [formControl]="getSurveyEnabledControl(i)" color="primary">
                                    Enable automatic survey sending
                                </mat-slide-toggle>

                                <div class="timing-options" *ngIf="getSurveyEnabledControl(i).value">
                                    <h5>When to send survey:</h5>

                                    <div class="timing-presets">
                                        <mat-radio-group formControlName="timingPreset">
                                            <mat-radio-button value="immediate">Immediately after
                                                appointment</mat-radio-button>
                                            <mat-radio-button value="1hour">1 hour after appointment</mat-radio-button>
                                            <mat-radio-button value="6hours">6 hours after
                                                appointment</mat-radio-button>
                                            <mat-radio-button value="1day">1 day after appointment</mat-radio-button>
                                            <mat-radio-button value="3days">3 days after appointment</mat-radio-button>
                                            <mat-radio-button value="1week">1 week after appointment</mat-radio-button>
                                            <mat-radio-button value="custom">Custom timing</mat-radio-button>
                                        </mat-radio-group>
                                    </div>

                                    <div class="custom-timing" *ngIf="template.get('timingPreset')?.value === 'custom'">
                                        <div class="custom-timing-fields">
                                            <mat-form-field appearance="outline" class="timing-field">
                                                <mat-label>Days</mat-label>
                                                <input matInput type="number" formControlName="surveyDelayDays" min="0"
                                                    max="30">
                                                <mat-hint>Days after appointment</mat-hint>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="timing-field">
                                                <mat-label>Hours</mat-label>
                                                <input matInput type="number" formControlName="surveyDelayHours" min="0"
                                                    max="23">
                                                <mat-hint>Hours after appointment</mat-hint>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Linked Appointment Types Section -->
                        <div class="linked-appointment-types-section">
                            <h4>Linked Appointment Types</h4>
                            <p class="hint">Select which appointment types should use this survey template.</p>
                            <mat-form-field class="full-width" appearance="outline">
                                <mat-label>Linked Appointment Types</mat-label>
                                <mat-chip-grid #appointmentTypeChipGrid>
                                    <mat-chip-row *ngFor="let linkedType of getLinkedAppointmentTypes(i)">
                                        {{ linkedType.type }}
                                        <button matChipRemove (click)="unlinkAppointmentType(i, linkedType.id)">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                </mat-chip-grid>
                                <input [matChipInputFor]="appointmentTypeChipGrid" disabled />
                            </mat-form-field>
                            <div class="link-appointment-type-section">
                                <h5>Link Appointment Type</h5>
                                <div class="link-form">
                                    <mat-form-field appearance="outline" class="appointment-type-select full-width">
                                        <mat-label>Select Appointment Type</mat-label>
                                        <mat-select [(ngModel)]="selectedAppointmentTypeId[i]"
                                            [ngModelOptions]="{standalone: true}"
                                            (selectionChange)="onAppointmentTypeSelectionChange(i, $event.value)">
                                            <mat-option *ngFor="let appointmentType of getAvailableAppointmentTypes(i)"
                                                [value]="appointmentType.id">
                                                {{ appointmentType.type }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                      
                        <!-- Action Buttons -->
                        <div class="action-buttons">
                            <!-- Debugging: Display form errors -->
                            <div *ngIf="template.invalid" class="form-errors">
                                <h6>Form is invalid. Errors:</h6>
                                <ul>
                                    <li *ngFor="let error of getFormValidationErrors(template)">
                                        <strong>{{ error.controlName }}:</strong> {{ error.errorName }} ({{ error.errorValue | json }})
                                    </li>
                                </ul>
                            </div>
                            
                            <button mat-raised-button color="warn" (click)="resetTemplate(i)" [disabled]="isSaving">
                                <mat-icon>restore</mat-icon>
                                Reset to Default
                            </button>
                            <button mat-raised-button color="primary" (click)="saveTemplate(i)"
                                [disabled]="isSaving || template.invalid">
                                <mat-icon>save</mat-icon>
                                {{ isSaving ? 'Saving...' : 'Save Template' }}
                            </button>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </mat-accordion>
    <div class="mobile-spacer"></div>

</div>